import client from '@/apis/http-client'
import Vue from 'vue'
import qs from 'qs'

const useMockData = false
const resource = 'patient-rooms'

const mockSource = [
  { id: 'room-1', org_codename: 'psuv', room_type: 'VIP', name_th: 'ห้องพิเศษ VIP', name_en: 'VIP Room', room_size: '35 sq.m.', cover_image: 'https://obs.example.com/rooms/vip-cover.jpg', images: ['https://obs.example.com/rooms/vip-1.jpg'], room_charge: 5000, food_charge: 800, nursing_charge: 900, service_charge: 500, updated_at: '2026-09-29T10:00:00Z' },
  { id: 'room-2', org_codename: 'ppnp', room_type: 'Deluxe', name_th: 'ห้องดีลักซ์', name_en: 'Deluxe Room', room_size: '30 sq.m.', cover_image: 'https://obs.example.com/rooms/deluxe-cover.jpg', images: ['https://obs.example.com/rooms/deluxe-1.jpg'], room_charge: 3600, food_charge: 700, nursing_charge: 600, service_charge: 400, updated_at: '2026-09-28T09:00:00Z' }
]

const defaultState = () => ({ currentPage: 1, pageSize: 10, total: 0, sortBy: 'updated_at', sortDesc: 'DESC', textSearch: '', filterOrgCode: '', filterCategory: '', list: [], isLoading: false, isSaving: false, orgOptions: [] })
const state = defaultState()
const generateMockId = (prefix) => `${prefix}-${Date.now()}-${Math.floor(Math.random() * 100000)}`

const actions = {
  setResource() {},
  async upload(_, payload) {
    try {
      const response = await client.secureHttpClient.post('/por/api/upload/obs', payload)
      return response?.data?.url || response?.data?.data?.url || ''
    } catch (e) {
      Vue.$log.error(e)
      return ''
    }
  },
  resetList({commit}) { commit('RESET_LIST_STATE') },
  setPage({commit}, page) { commit('SET_PAGE', page) },
  setPageSize({commit}, size) { commit('SET_PAGE_SIZE', size) },
  setTextSearch({commit}, text) { commit('SET_TEXT_SEARCH', text) },
  setFilterOrgCode({commit}, orgCode) { commit('SET_FILTER_ORG_CODE', orgCode) },
  setFilterCategory({commit}, category) { commit('SET_FILTER_CATEGORY', category) },
  async fetchOrgOptions({commit}) {
    if (useMockData) {
      commit('SET_ORG_OPTIONS', [{text: 'psuv - Princ Suvarnabhumi', value: 'psuv'}, {text: 'ppnp - Princ Pak Nam Pho', value: 'ppnp'}, {text: 'pkkp - Princ Khon Kaen', value: 'pkkp'}])
      return
    }
    try {
      const response = await client.secureHttpClient.get('/por/api/organization/permission?permission=View&category=Organization')
      const data = response?.data?.data || response?.data || []
      commit('SET_ORG_OPTIONS', (data || []).map((item) => {
        const codename = String(item.codename || item.value || '').toLowerCase()
        const name = item.name || item.name_th || item.text || codename.toUpperCase()
        return { text: `${codename} - ${name}`, value: codename }
      }).filter(item => item.value))
    } catch (e) { Vue.$log.error(e); commit('SET_ORG_OPTIONS', []) }
  },
  async fetch({commit, state}) {
    commit('SET_IS_LOADING', true)
    if (useMockData) {
      let data = [...mockSource]
      if (state.filterOrgCode) data = data.filter(item => item.org_codename === state.filterOrgCode)
      if (state.textSearch) {
        const term = state.textSearch.toLowerCase()
        data = data.filter(item => `${item.name_en || ''} ${item.name_th || ''} ${item.room_type || ''}`.toLowerCase().includes(term))
      }
      commit('SET_LIST', data); commit('SET_TOTAL', data.length); commit('SET_IS_LOADING', false); return
    }
    try {
      const response = await client.secureHttpClient.get(`/por/api/${resource}`, { params: { page: state.currentPage, limit: state.pageSize, orderBy: state.sortBy, sort: state.sortDesc, search: state.textSearch, org_codename: state.filterOrgCode }, paramsSerializer: localParams => qs.stringify(localParams, {encode: false}) })
      const resData = response?.data || {}
      const list = resData.results || resData.data || []
      const total = resData.total !== undefined ? resData.total : list.length
      commit('SET_LIST', Array.isArray(list) ? list : [])
      commit('SET_TOTAL', total)
    } catch (e) { Vue.$log.error(e); commit('SET_LIST', []); commit('SET_TOTAL', 0) }
    commit('SET_IS_LOADING', false)
  },
  async save({commit}, payload) {
    commit('SET_IS_SAVING', true)
    if (useMockData) {
      if (payload.id) {
        const index = mockSource.findIndex(item => item.id === payload.id)
        if (index !== -1) mockSource[index] = {...mockSource[index], ...payload, updated_at: new Date().toISOString()}
      } else {
        mockSource.unshift({...payload, id: generateMockId('room'), updated_at: new Date().toISOString()})
      }
      commit('SET_IS_SAVING', false)
      return {ok: true, message: ''}
    }
    try {
      if (payload.id) await client.secureHttpClient.put(`/por/api/${resource}/${payload.id}`, payload)
      else await client.secureHttpClient.post(`/por/api/${resource}`, payload)
      commit('SET_IS_SAVING', false)
      return {ok: true, message: ''}
    } catch (e) { Vue.$log.error(e); commit('SET_IS_SAVING', false); return {ok: false, message: e?.response?.data?.message || 'Unable to save'} }
  },
  async deleteById(_context, id) {
    if (useMockData) { const index = mockSource.findIndex(item => item.id === id); if (index !== -1) mockSource.splice(index, 1); return true }
    try { await client.secureHttpClient.delete(`/por/api/${resource}/${id}`); return true } catch (e) { Vue.$log.error(e); return false }
  }
}

const mutations = {
  RESET_LIST_STATE(state) { state.currentPage = 1; state.pageSize = 10; state.total = 0; state.sortBy = 'updated_at'; state.sortDesc = 'DESC'; state.textSearch = ''; state.filterOrgCode = ''; state.filterCategory = ''; state.list = [] },
  SET_PAGE(state, page) { state.currentPage = page },
  SET_PAGE_SIZE(state, size) { state.pageSize = size },
  SET_TEXT_SEARCH(state, text) { state.textSearch = text },
  SET_FILTER_ORG_CODE(state, orgCode) { state.filterOrgCode = orgCode },
  SET_FILTER_CATEGORY(state, category) { state.filterCategory = category },
  SET_LIST(state, list) { state.list = list },
  SET_TOTAL(state, total) { state.total = total },
  SET_IS_LOADING(state, isLoading) { state.isLoading = isLoading },
  SET_IS_SAVING(state, isSaving) { state.isSaving = isSaving },
  SET_ORG_OPTIONS(state, orgOptions) { state.orgOptions = orgOptions }
}

export default { namespaced: true, state, actions, mutations }
